module.exports = __webpack_public_path__ + "static/media/19.759c2c77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/19.svg
// module id = 131
// module chunks = 0